import React from "react";

export interface IconCirclePlusProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const IconCirclePlus: React.FC<IconCirclePlusProps> = ({
  width = 32,
  height = 32,
  fill = "#006231",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 28.7992C23.07 28.7992 28.7999 23.0692 28.7999 15.9992C28.7999 8.92922 23.07 3.19922 16 3.19922C8.92995 3.19922 3.19995 8.92922 3.19995 15.9992C3.19995 23.0692 8.92995 28.7992 16 28.7992ZM14.8 20.3992V17.1992H11.6C10.935 17.1992 10.4 16.6642 10.4 15.9992C10.4 15.3342 10.935 14.7992 11.6 14.7992H14.8V11.5992C14.8 10.9342 15.335 10.3992 16 10.3992C16.665 10.3992 17.2 10.9342 17.2 11.5992V14.7992H20.4C21.065 14.7992 21.6 15.3342 21.6 15.9992C21.6 16.6642 21.065 17.1992 20.4 17.1992H17.2V20.3992C17.2 21.0642 16.665 21.5992 16 21.5992C15.335 21.5992 14.8 21.0642 14.8 20.3992Z"
      fill={fill}
    />
  </svg>
);
